import { Input } from '@starsoft/common/components';
import styles from '../styles.module.scss';
import skeletonStyles from './styles.module.scss';
import UserPhoneNumberFormVerifySkeleton from '../Verify/Skeleton';

export default function UserEmailFormSkeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.container__content}>
        <div className={skeletonStyles['lottie-skeleton']} />
        <div className={skeletonStyles['text-column']}>
          {Array.from({ length: 2 }).map((_, index) => (
            <div
              key={`text-skeleton-${index}`}
              className={skeletonStyles['text-skeleton']}
            />
          ))}
        </div>

        <UserPhoneNumberFormVerifySkeleton />
      </div>

      <div className={styles.container__button}>
        <Input isLoading />
      </div>
    </div>
  );
}
